// extracted by mini-css-extract-plugin
export default {"SchedulerBackgroundClass":"SchedulerBackgroundClass_CovPG","appointmentForm":"appointmentForm_D_wbN","disabled":"disabled_txTE1"};